// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__8jjli","centerDiv":"modal_centerDiv__R6ZoE","backdrop":"modal_backdrop__mmge3","centerModal":"modal_centerModal__K67iY"};